import React from 'react'
import { Helmet } from 'react-helmet'
import { LayoutProvider } from 'modules/Layout'
import { Layout, LayoutBody, LayoutContent } from 'views/components'
import EnableUser from './EnableUser/EnableUser'
import styles from './AdminOnboardingPage.module.scss'
import BulkImportContacts from './BulkImportContacts/BulkImportContacts'

const AdminOnboardingPage = () => {
  return (
    <div className={styles.root}>
      <LayoutProvider
        stateKey="segments"
        initialProps={{
          sidebar: { open: false, width: 0 },
          primaryPanel: { open: false, width: 752 },
          secondaryPanel: { open: false, width: 375 },
        }}
      >
        <Helmet>
          <title>reOS | Admin | Onboarding</title>
        </Helmet>
        <Layout>
          <LayoutBody>
            <LayoutContent>
              <div>
                <BulkImportContacts />
                <EnableUser />
              </div>
            </LayoutContent>
          </LayoutBody>
        </Layout>
      </LayoutProvider>
    </div>
  )
}

export default AdminOnboardingPage
